import karlaItalic from './Karla-Italic.woff2';
import karlaRegular from './Karla-Regular.woff2';
import karlaBold from './Karla-Bold.woff2';
import karlaBoldItalic from './Karla-Regular.woff2';

export const karlaFont = {
    italic: {
        fontFamily: "'Karla'",
        fontStyle: 'italic',
        fontWeight: '400',
        fontDisplay: 'swap',
        src: `local('Karla Italic'), local('Karla-Italic'), url(${karlaItalic}) format('woff2')`,
        unicodeRange:
            'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
    boldItalic: {
        fontFamily: "'Karla'",
        fontStyle: 'italic',
        fontWeight: '700',
        fontDisplay: 'swap',
        src: `local('Karla Bold Italic'), local('Karla-BoldItalic'), url(${karlaBoldItalic}) format('woff2')`,
        unicodeRange:
            'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },

    regular: {
        fontFamily: "'Karla'",
        fontStyle: 'normal',
        fontWeight: '400',
        fontDisplay: 'swap',
        src: `local('Karla'), local('Karla-Regular'), url(${karlaRegular}) format('woff2')`,
        unicodeRange:
            'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
    bold: {
        fontFamily: "'Karla'",
        fontStyle: 'normal',
        fontWeight: '700',
        fontDisplay: 'swap',
        src: `local('Karla Bold'), local('Karla-Bold'), url(${karlaBold}) format('woff2')`,
        unicodeRange:
            'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
};
